module.exports = __webpack_public_path__ + "static/media/tilde.722a182c.svg";